import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ACTIONS as CHAT_ACTIONS } from "../../../redux/chat";
import { Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import DeleteIcon from "@mui/icons-material/Delete";

import StyledDeleteModal from "./styles";

const DeleteModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const { currentChat, api } = useSelector((state) => state.chat);
  const { info } = currentChat;

  const onDeleteChatHandler = () => {
    dispatch(CHAT_ACTIONS.deleteCurrentChat());
  };

  return (
    <StyledDeleteModal>
      <div className="delete-modal">
        <div className="delete-modal-background" onClick={onClose} />
        <div className="delete-modal-content">
          <div className="delete-modal-text">
            <Typography variant="h5">
              Eliminar chat con {info.name} ?
            </Typography>
            <Typography variant="body1" color="#CE345A">
              Si lo haces, se borrarán todos los mensajes para ti y para{" "}
              {info.name} y no podrás volver a acceder a ellos.
            </Typography>
          </div>
          <div className="delete-modal-button">
            <LoadingButton
              startIcon={<DeleteIcon />}
              variant="contained"
              color="error"
              size="large"
              onClick={onDeleteChatHandler}
              loading={api.loading}
            >
              Eliminar chat
            </LoadingButton>
          </div>
        </div>
      </div>
    </StyledDeleteModal>
  );
};

export default DeleteModal;
